<template>
  
  <div class="panel panel-default">      
    <div class="panel-body">
       <ul class="slide-doi-tac"> 
        <li class="news-item">
          <img src="/img/upload/doi-tac-1.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-2.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-3.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-4.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-5.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-6.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-7.jpg" class="img-circle" alt="" height="40" >        	
        </li> 
       <li class="news-item">
          <img src="/img/upload/doi-tac-8.jpg" class="img-circle" alt="" height="40" >        	
        </li>
        <li class="news-item">
          <img src="/img/upload/doi-tac-9.jpg" class="img-circle" alt="" height="40" >        	
        </li>
       </ul>        
    </div>     
  </div>
  
  
    
</template>
<script>
export default {
  name: "RwvPartner" 
};
</script>
<style>
.glyphicon { 
  margin-right:4px !important;
  }
 
.pagination .glyphicon {    
  margin-right:0px !important; 
}
.pagination a { color:#555;}
.panel ul { 
    padding:0px;    
    margin:0px; 
    list-style:none;
} 
.news-item {    
    padding:4px 4px;    
    margin:0px; 
    border-bottom:1px dotted #555;
}
</style>